// Fetch tenant planner settings
export const FETCH_DEGREE_PLANNING_SETTINGS = 'FETCH_DEGREE_PLANNING_SETTINGS';
export const FETCH_DEGREE_PLANNING_SETTINGS_SUCCESS = 'FETCH_DEGREE_PLANNING_SETTINGS_SUCCESS';
export const FETCH_DEGREE_PLANNING_SETTINGS_ERROR = 'FETCH_DEGREE_PLANNING_SETTINGS_ERROR';

// Save tenant planner settings
export const UPDATE_DEGREE_PLANNING_SETTINGS = 'UPDATE_DEGREE_PLANNING_SETTINGS';
export const UPDATE_DEGREE_PLANNING_SETTINGS_SUCCESS = 'UPDATE_DEGREE_PLANNING_SETTINGS_SUCCESS';
export const UPDATE_DEGREE_PLANNING_SETTINGS_ERROR = 'UPDATE_DEGREE_PLANNING_SETTINGS_ERROR';
